import { ExportToRegistryDto } from "types/dto/ExportToRegistryDto";
import { ApiService } from "./apiService"
import { RegistryDataType } from "types/types";
import { ListRegistriesDto } from "types/dto/ListRegistriesDto";
import { PatientsFiltersDto } from "types/dto/PatientsFiltersDto";
import { ListRegistryPatientsDto } from "types/dto/ListRegistryPatientsDto";
import { GetRegistryPatientDto } from "types/dto/GetRegistryPatientDto";
import { UpdateRegistryDto } from "types/dto/UpdateRegistryDto";



export const exportCasesToRegistry = async (dto: ExportToRegistryDto) => {
    return await ApiService.post(`registries/${dto.registryId}/procedures/import-from-dashboard`, { procedure_ids: dto.procedureIds });
}

export const createRegistry = async (dto: RegistryDataType) => {
    return await ApiService.post(`registries`, dto);
}

export const updateRegistry = async (dto: UpdateRegistryDto) => {
    const { registryId, ...data } = dto;
    return await ApiService.put(`registries/${registryId}`, data);
}

export const getRegistries = async (dto: ListRegistriesDto) => {
    return await ApiService.get(`registries?order_by=name&sort_by=ASC&group=${dto.group}&page=${dto.page}&page_size=${dto.pageLimit}`);
}

export const getRegistryById = async (registryId: number) => {
    const result = await ApiService.get(`registries/${registryId}`);
    return result
}

export const getRegistryPatients = async (dto: ListRegistryPatientsDto) => {
    return await ApiService.get(`registries/${dto.registryId}/procedures?page=${dto.page}&page_size=${dto.pageLimit}&filter=${dto.filter}&search_by=${dto.search_by}&value=${dto.value}`);
}

export const getRegistryPatientById = async (dto: GetRegistryPatientDto) => {
    return await ApiService.get(`registries/${dto.registryId}/procedures/${dto.patientId}`);
}

export const deleteRegistry = async (registryId: number) => {
    return await ApiService.delete(`registries/${registryId}`);
}
